<template>
  <header>
    <b-navbar class="ef-navbar shadow-sm bg-white paddin-3" fixed="top" toggleable="lg" type="light" variant="light">
      <b-navbar-brand class="ef-logo-text" :href="logoRedirect()">
        <img class="ef-logo" src="../assets/EliteFitAI-Logo.svg" alt="EliteFit" />
        ELITEFIT.AI
      </b-navbar-brand>
      <!-- <b-navbar-brand class="ef-logo-text" href="user/discover">
        <img class="ef-logo" src="../assets/EliteFitAI-Logo.svg" alt="EliteFit" />
        ELITEFIT.AI
      </b-navbar-brand> -->

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" class="ml-lg-4 p-4 p-lg-0 bg-white text-center" is-nav>
        <b-navbar-nav>
          <!-- Desktop nav menu -->
          <b-nav-item class="ef-nav-item  d-none d-lg-block" link-classes="px-4" active-class="font-weight-bolder"
            @click="toggleAISolMenu()">SOLUTIONS
            <span v-if="!showAISolMenu"><img src="../assets/icons/drop-down-down-arrow.svg"></span>
            <span v-else><img src="../assets/icons/drop-down-up-arrow.svg"></span>
          </b-nav-item>
          <!-- Mobile sub menu -->
          <b-nav-item-dropdown text="WHO WE SERVE" class="d-sm-block d-lg-none nav-work-with-us" variant="primary" block>
            <b-dropdown-item active-class="font-weight-bold" :to="'/healthcare'">Healthcare</b-dropdown-item>
            <b-dropdown-item active-class="font-weight-bold" :to="'/fitness'">Fitness/Yoga</b-dropdown-item>
            <b-dropdown-item active-class="font-weight-bold" :to="'/sports'">Sports</b-dropdown-item>
            <b-dropdown-item active-class="font-weight-bold" :to="'/insurance'">Insurance</b-dropdown-item>
            <b-dropdown-item active-class="font-weight-bold" :to="'/publicsector'">Public Sector</b-dropdown-item>
            <!-- <b-dropdown-item active-class="font-weight-bold" :to="'/schools'">Schools</b-dropdown-item> -->
          </b-nav-item-dropdown>
          <!-- Desktop nav menu -->
          <b-nav-item class="ef-nav-item d-none d-lg-block" link-classes="px-4" active-class="font-weight-bolder"
            @click="toggleWhyEFMenu()">ABOUT
            <span v-if="!showWhyEFMenu"><img src="../assets/icons/drop-down-down-arrow.svg"></span>
            <span v-else><img src="../assets/icons/drop-down-up-arrow.svg"></span>
          </b-nav-item>
          <!-- Mobile sub menu -->
          <b-nav-item-dropdown text="ABOUT ELITEFIT" class="d-sm-block d-lg-none nav-work-with-us" variant="primary"
            block>
            <b-dropdown-item active-class="font-weight-bold" :to="'/our-journey'">Why EliteFit.AI</b-dropdown-item>
            <b-dropdown-item active-class="font-weight-bold" :to="'/careers'">Careers</b-dropdown-item>
            <b-dropdown-item active-class="font-weight-bold" :to="'/contact-us'">Contact Us</b-dropdown-item>

          </b-nav-item-dropdown>

          <b-nav-item class="ef-nav-item d-none d-lg-block" link-classes="px-4" active-class="font-weight-bolder"
            @click="toggleResourcesMenu()">RESOURCES
            <span v-if="!showResourcesMenu"><img src="../assets/icons/drop-down-down-arrow.svg"></span>
            <span v-else><img src="../assets/icons/drop-down-up-arrow.svg"></span>
          </b-nav-item>

          <b-nav-item-dropdown text="RESOURCES" class="d-sm-block d-lg-none nav-work-with-us" variant="primary" block>
            <b-dropdown-item active-class="font-weight-bold" :to="'/videos'">Videos</b-dropdown-item>
            <b-dropdown-item active-class="font-weight-bold" :to="'/press'">Press</b-dropdown-item>
            <b-dropdown-item active-class="font-weight-bold" :to="'/faqs'">FAQs</b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item class="ef-nav-item d-none d-lg-block" link-classes="px-4" active-class="font-weight-bolder"
            @click="toggleAIMenu()">TOOLS
            <span v-if="!showAIMenu"><img src="../assets/icons/drop-down-down-arrow.svg"></span>
            <span v-else><img src="../assets/icons/drop-down-up-arrow.svg"></span>
          </b-nav-item>
          <b-nav-item-dropdown text="AI TOOLS" class="d-sm-block d-lg-none nav-work-with-us" variant="primary" block>
            <b-dropdown-item active-class="font-weight-bold" :to="'/smb'">Fitness/Yoga</b-dropdown-item>
          </b-nav-item-dropdown>
          <!-- Mobile sub menu -->

        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <!-- <b-nav-item v-if="anonymous" class="ef-nav-item">
            <LanguageSwitcher class="mx-auto mx-lg-0 w-fit-content" ref="googleTranslateDropdown" :minimal="true" :light-theme="false"></LanguageSwitcher>
          </b-nav-item> -->
          <b-nav-item v-if="anonymous" class="ef-nav-item" link-classes="mr-md-5" active-class="font-weight-bolder"
            :to="'/ef/sign-in'" ><span style="color: #73BC44 !important;">SIGN IN</span></b-nav-item>
          <!-- <b-nav-item v-if="anonymous" class="ef-nav-item" link-classes="px-4" active-class="font-weight-bolder" :to="'/ef/sign-in'">SIGN IN</b-nav-item> -->
          <b-button v-if="anonymous" class="menu-btn shadow-sm" @click="tryDemo">TRY NOW</b-button>
          <!-- <b-button name="burgerIcon" v-if="!anonymous" class="menu-btn shadow-sm" @click="openBurgerMenu">Menu</b-button> -->
          <HeaderDropdown v-if="!anonymous"/>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <div class="stagingContainer">
      <!-- Desktop nav sub menu -->
      <div class="staging-warning w-100 d-none d-lg-block" v-if="showAISolMenu || showWhyEFMenu || showResourcesMenu || showAIMenu"
        @click="toggleSubMenu()">
        <b-navbar-nav class="d-flex flex-lg-row justify-content-center" v-if="showAISolMenu">
          <b-nav-item class="ef-nav-item" link-classes="ef-sub-menu-text-color px-4"
            active-class="font-weight-bolder text-white" :to="'/healthcare'">Healthcare</b-nav-item>
          <b-nav-item class="ef-nav-item" link-classes="ef-sub-menu-text-color px-4"
            active-class="font-weight-bolder text-white" :to="'/fitness'">Fitness/Yoga</b-nav-item>
          <!-- <b-nav-item class="ef-nav-item" link-classes="ef-sub-menu-text-color px-4"
            active-class="font-weight-bolder text-white" :to="'/yoga'">Yoga</b-nav-item> -->
          <b-nav-item class="ef-nav-item" link-classes="ef-sub-menu-text-color px-4"
            active-class="font-weight-bolder text-white" :to="'/sports'">Sports</b-nav-item>
          <b-nav-item class="ef-nav-item" link-classes="ef-sub-menu-text-color px-4"
            active-class="font-weight-bolder text-white" :to="'/insurance'">Insurance</b-nav-item>
          <b-nav-item class="ef-nav-item" link-classes="ef-sub-menu-text-color px-4"
            active-class="font-weight-bolder text-white" :to="'/publicsector'">Public Sector</b-nav-item>
          <!-- <b-nav-item class="ef-nav-item" link-classes="ef-sub-menu-text-color px-4"
            active-class="font-weight-bolder text-white" :to="'/schools'">Schools</b-nav-item> -->
        </b-navbar-nav>

        <b-navbar-nav class="d-flex flex-lg-row justify-content-center" v-if="showWhyEFMenu">
          <b-nav-item class="ef-nav-item" link-classes="ef-sub-menu-text-color px-4"
            active-class="font-weight-bolder text-white" :to="'/our-journey'">Why EliteFit.AI</b-nav-item>
          <b-nav-item class="ef-nav-item" link-classes="ef-sub-menu-text-color px-4"
            active-class="font-weight-bolder text-white" :to="'/careers'">Careers</b-nav-item>
          <b-nav-item class="ef-nav-item" link-classes="ef-sub-menu-text-color px-4"
            active-class="font-weight-bolder text-white" :to="'/contact-us'">Contact Us</b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav class="d-flex flex-lg-row justify-content-center" v-if="showResourcesMenu">
          <b-nav-item class="ef-nav-item" link-classes="ef-sub-menu-text-color px-4" active-class="font-weight-bolder text-white" :to="'/casestudies'">Case Studies</b-nav-item>
          <b-nav-item class="ef-nav-item" link-classes="ef-sub-menu-text-color px-4"
            active-class="font-weight-bolder text-white" :to="'/videos'">Videos</b-nav-item>
          <b-nav-item class="ef-nav-item" link-classes="ef-sub-menu-text-color px-4"
            active-class="font-weight-bolder text-white" :to="'/press'">Press</b-nav-item>
          <b-nav-item class="ef-nav-item" link-classes="ef-sub-menu-text-color px-4"
            active-class="font-weight-bolder text-white" :to="'/faqs'">FAQs</b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav class="d-flex flex-lg-row justify-content-center" v-if="showAIMenu">
          <b-nav-item class="ef-nav-item" link-classes="ef-sub-menu-text-color px-4"
            active-class="font-weight-bolder text-white" :to="'/smb'">Fitness/Yoga</b-nav-item>
        </b-navbar-nav>
      </div>
      <div class="staging-warning" v-if="!isProd && isShown">
        This is a test site for internal use only. Please visit <a class="site-link-text"
          href="https://www.elitefit.ai">www.elitefit.ai</a>.
        <a class="dismiss-text" v-on:click="toggleIsShown()">Click to dismiss.</a>
      </div>
    </div>

    <EFHeader :hide-name-and-menu="true"></EFHeader>
    <div style="height: 54.5px" v-if="open"></div>

  </header>
</template>

<script>
import EFHeader from "@/views/EFHeader";
import { mapMutations, mapGetters } from "vuex";
import { DEFAULT_VIDEOS } from "@/utils/config";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import HeaderDropdown from "@/components/HeaderDropdown";

export default {
  data: function () {
    return {
      isShown: true,
      showAISolMenu: true,
      showWhyEFMenu: false,
      showResourcesMenu: false,
      showAIMenu: false,
      open: true,
    }
  },
  name: "EfHeader",
  components: {
    EFHeader,
    LanguageSwitcher,
    HeaderDropdown
  },
  computed: {
    ...mapGetters(["isAdmin"]),
    loggedInUser() {
      return localStorage.getItem("userInfo");
    },
    anonymous() {
      if (this.$store.state.userInfo) {
        return this.$store.state.userInfo?.isAnonymousUser;
      } else {
        return true;
      }
    },
    isProd() {
      return [
        'elitefitforyou.com',
        'www.elitefitforyou.com',
        'elitefit.ai',
        'wwww.elitefit.ai',
      ].includes(location.hostname)
    },
    isMobile() {
      const isAndroid = /Android/i.test(navigator.userAgent);
      const isiOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      return isAndroid || isiOS;
    }
  },
  methods: {
    ...mapMutations(["setCloseOnHeader", "openBurgerMenu", "closeBurgerMenu"]),
    toggleIsShown() {
      this.isShown = false;
    },
    logoRedirect(){
      const userInfo = this.$store.state.userInfo;
      return userInfo && userInfo.isAnonymousUser === false ?"user/discover" : "home";
    },
    tryDemo() {
      let defaultVideos = JSON.parse(DEFAULT_VIDEOS);
      let videoId = defaultVideos[Math.floor(Math.random() * defaultVideos.length)];
      this.$router.push("/PremiumFeedback");
    },
    toggleAISolMenu() {
      this.showWhyEFMenu = false;
      this.showResourcesMenu = false;
      this.showAIMenu = false;
      this.showAISolMenu = !this.showAISolMenu;
      this.setopen()
    },
    toggleWhyEFMenu() {
      this.showAISolMenu = false;
      this.showResourcesMenu = false;
      this.showAIMenu = false;
      this.showWhyEFMenu = !this.showWhyEFMenu;
      this.setopen()
    },
    toggleResourcesMenu() {
      this.showAISolMenu = false;
      this.showWhyEFMenu = false;
      this.showAIMenu = false;
      this.showResourcesMenu = !this.showResourcesMenu;
      this.setopen()
    },
    toggleAIMenu() {
      this.showAISolMenu = false;
      this.showWhyEFMenu = false;
      this.showResourcesMenu = false;
      this.showAIMenu = !this.showAIMenu;
      this.setopen()
    },
    toggleAboutMenu() {
      this.showWorkWithUsMenu = false;
      this.showAboutMenu = !this.showAboutMenu;
    },
    toggleWorkWithUsMenu() {
      this.showAboutMenu = false;
      this.showWorkWithUsMenu = !this.showWorkWithUsMenu;

    },
    toggleSubMenu() {
      this.showAISolMenu = false;
      this.showWhyEFMenu = false;
      this.showResourcesMenu = false;
    },
    setopen(){
      setTimeout(() => {
        this.open = !!document.querySelector('.staging-warning .navbar-nav')
      }, 5);
    }
  },
  mounted() {
    this.$refs.googleTranslateDropdown?.$el.addEventListener("click", function (event) {
      // Stop propagation to prevent Bootstrap nav dropdown from closing
      console.log("Dropdown clicked");
      event.stopPropagation();
    });
  }
}
</script>

<style lang="scss">
.profile-img {
  width: wrap !important;
  height: wrap !important;
  max-width: 100%;
  max-height: 70%;
  box-shadow: 0px 16px 49px rgba(20, 21, 19, 0.15);
  border-radius: 100px;
}

.dropdown-menu.show {
  background-color: #73bc44 !important;

  .dropdown-item,
  .dropdown-item:focus {
    color: rgba(255, 255, 255, 0.75) !important;
    background-color: #73bc44 !important;
  }

  .router-link-exact-active {
    color: white !important;
  }
}

::v-deep .profile-img .dropdown-menu.show {
  background-color: white !important;
}

::v-deep .profile-img .dropdown .nav-link {
  color: #73BC44 !important;
}

::v-deep .profile-img .dropdown span {
  color: #141513 !important;
}

::v-deep .profile-img .dropdown .dropdown-item {
  color: #73BC44 !important;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  background-color: white !important;
}

::v-deep .profile-img .dropdown-toggle {
  color: #73BC44 !important;
}

::v-deep .dropdown-menu-right {
  z-index: 10;
}

.nav-link .router-link-exact-active {
  color: #73bc44 !important;
}

.dropdown-menu {
  text-align: center !important;
  border-left: 0 !important;
  border-right: 0 !important;
  background-color: white !important;
}

.navbar-light .navbar-nav .nav-link {
  color: black !important;
}

.dropdown-item.active,
.dropdown-item:active {
  background-color: white !important;
  color: black !important;
}

.nav-work-with-us {
  font-weight: 600 !important;
  font-size: 15px !important;
}

.ef-logo {
  height: 60px;
  margin: 0 5px;
}

.ef-sub-menu {
  width: 100%;
  height: 10%;
  background-color: #73bc44;
  z-index: 3;
  position: absolute;
}

.ef-sub-menu-text-color {
  color: rgba(255, 255, 255, 0.75) !important;
}

.ef-sub-menu-text-color:hover {
  color: rgb(255, 255, 255) !important;
}

.ef-sub-menu-text-color.router-link-exact-active {
  color: rgb(255, 255, 255) !important;
}

.ef-logo-text {
  letter-spacing: 3px;
}

.stagingContainer {
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  position: fixed;
  top: 80px;
  right: 0;
  left: 0;
  z-index: 1000;
}

.staging-warning {
  padding: 8px 10px;
  color: black;
  background-color: #73bc44;
  width: fit-content;
  margin: auto;
  font-size: 18px;
}

.site-link-text {
  color: #fff;
}

.dismiss-text {
  color: blue !important;
  text-decoration: underline !important;
  cursor: pointer;
}

.ef-navbar {
  height: 80px;

  .efLogoBeta {
    color: #343a40 !important;
    font-weight: 600;
    font-size: 75%;
    font-style: italic;
    position: relative;
    vertical-align: baseline;
    bottom: -1.25em;
  }
}

.ef-nav-item {
  .nav-link {
    color: rgba(255, 255, 255, 0.75);
    font-size: 15px;
    font-weight: 600;
  }
}

.ef-nav-item {
  .color-primary {
    color: #73BC44 !important;
    font-size: 15px;
    font-weight: 600;
  }
}

.try-now {
  background-color: #73BC44;
  border-radius: 50px;
  padding-left: 10px;
  padding-right: 10px;

  .nav-link {
    color: #FFFFFF !important;
  }
}

.menu-btn {
  background-color: #73BC44 !important;
  color: #FFFFFF;
  font-size: 15px !important;
  font-weight: bold !important;
  border-radius: 50px !important;
  padding: 7px 17px !important;
  border: none !important;

  :focus {
    outline: none !important;
  }
}

.menu-btn:hover {
  background: #6c757d !important;
  text-decoration: unset !important;
}

.paddin-3{
  padding: 1rem !important;
}

@media screen and (max-width: 993px) {
  
  .ef-logo {
    height: 55px;
  }

  .paddin-3{
    padding: 0 0.5rem !important;
  }
}

@media screen and (max-width: 900px) {
  .staging-warning {
    padding: 2px 4px !important;
    font-size: 11px !important;
  }
}

@media screen and (max-width: 1024px) {
  .staging-warning {
    padding: 4px 8px;
    color: black;
    background-color: #73bc44;
    width: fit-content;
    margin: auto;
    font-size: 15px;
  }

  .profile-img {
    box-shadow: unset;
    width: 100%;
    background-color: transparent !important;

    .nav-item {
      width: 100%;
    }
  }
}</style>
